export default __webpack_public_path__ + "static/media/removeForm.aba7e047.svg";